export default __webpack_public_path__ + "static/domea-3-555b2dd816ee6d3714475a4456e5fe0e.jpg";